import React from 'react'
import {
  ToggleButtonProps as MuiToggleButtonProps,
  ToggleButton as MuiToggleButton,
} from '@mui/material'

type ToggleButtonProps = MuiToggleButtonProps & {
  label?: string
}

export const ToggleButton = ({
  label,
  children,
  ...props
}: ToggleButtonProps) => {
  return (
    <MuiToggleButton
      value="percentage"
      sx={{
        '&.Mui-selected': {
          backgroundColor: 'primary.main',
          color: '#fff',
          '&:hover': { backgroundColor: 'primary.dark' },
        },
      }}
      {...props}
    >
      {label || children}
    </MuiToggleButton>
  )
}
